import { render } from "./MessageBoxQuestion.vue?vue&type=template&id=785ad306"
import script from "./MessageBoxQuestion.vue?vue&type=script&lang=js"
export * from "./MessageBoxQuestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__